module.exports = "/_next/static/images/ls-79261c0847aa6887c9c0224c04f7993b.svg";